export default "__VITE_ASSET__CCfPU19W__"